import styles from "./CartItems.module.css";
import Button from "../Button";

import { deleteCartItem, removeLocalItem } from "../../store/slices/cartSlice";
import { useDispatch } from "react-redux";

const Item = ({ item }) => {

  const dispatch = useDispatch()

  const handleDeleteItem = async () => {
    if (item.isLocal) {
      dispatch(removeLocalItem(item.product));
      return;
    }
    try {
      await dispatch(deleteCartItem(item.id)).unwrap();
    } catch (error) {
      console.error('Failed to delete cart item:', error);
    }
  };

  return (
    <div className={styles.itemCont}>
      <div className={styles.start}>
         <div><div className={styles.priceCont}>{item.discounted_price === 0 || item.price === 0 ? 'FREE' : `$${item.discounted_price || item.price}`}</div></div>
        {item.product_name}
        <span style={{ opacity: 0.7, fontSize: '0.85em', marginLeft: '8px' }}>
            {item.price_tier === "grids_only" ? "Grids only" : "Full package"}
        </span>
      </div>
      <Button
        labelPosition="none"
        variant="transparent"
        iconType="delete"
        color="red"
        onClick={handleDeleteItem}
      />
    </div>
  );
};

export default Item;
